// @flow
import * as React from 'react';
import Group from 'sail/Group';

type FlowChartType = 'default' | 'intents';

type FlowChartProps = {|
  type: FlowChartType,
  children: React.Node,
|};

export const FlowChart = ({type = 'default', children}: FlowChartProps) => {
  return (
    <Group
      className={`FlowChart-${type}`}
      direction="vertical"
      margin={{top: 32, left: 16}}
    >
      {children}
    </Group>
  );
};
